import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {PortosModel} from "./portos.model";
import { PortosService } from './portos.service';
import {Funcoes} from "../funcoes";
import {PaisesService} from "../paises/paises.service";
import {Global} from "../global";


@Component({
  selector: 'app-portos-form',
  templateUrl: './portos-form.component.html'
})
export class PortosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  porto: PortosModel = new PortosModel();
  listPaises = [];
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private portosService: PortosService,
    private paisesService: PaisesService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      id_pais: [],
      iniciais: []
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_porto'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarPorto');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarPorto') : this.func.traduzir('front.cadastrarNovoPorto');
      }


      this.paisesService.get()
        .subscribe(
          json => {
            this.listPaises = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      if (!id) {
        return;
      }

      this.portosService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.title = this.func.traduzir('front.editarPorto')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarPorto') + ': ' + json.Payload[0].nome;
            }
            this.porto = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.portosService.editar(values, values.id);
    } else {
      result = this.portosService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'portos']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/portos/portos-form.component.ts